export default __webpack_public_path__ + "static/media/_소슬러시_ 과일노트 블루 (줄).baa79e08.png";